


function update_selected_variant(){

  //first find out which variant we have to select
  var selected = ["","",""]
  $(".product-options .option-button.active").each(function(i,e){
    var this_option_value = $(this).attr("data-value")
    selected[i] = this_option_value
  })

  var props = `[data-option-1='${selected[0]}'][data-option-2='${selected[1]}'][data-option-3='${selected[2]}']`

  $("#product-select").find(`option` + props).prop('selected', true)

  var this_qty = $("#product-select").find("option:selected").attr("data-stock")
  var this_variant = $("#product-select").find("option:selected").attr("data-id")
  toolkit.set_query_variable("variant",this_variant)

  var this_policy = $("#product-select").find("option:selected").attr("data-policy")
  var this_price = $("#product-select").find("option:selected").attr("data-price")
  var this_sku = $("#product-select").find("option:selected").attr("data-sku")

  $(".sku p").text("SKU: " + this_sku)
  $(".pricing .actual-price").html("$" + this_price)

  //if allow overselling, let them add to cart
  if (parseInt(this_qty) > 0 || this_policy == "continue"){
    $(".atc-trigger.primary").removeClass("disabled")
    $(".stock-status .available").show()
    $(".stock-status .unavailable").hide()
  }
  else {
    $(".atc-trigger.primary").addClass("disabled")
    $(".stock-status .available").hide()
    $(".stock-status .unavailable").show()
  }


  //update the "Affirm" price
  var payment_price = parseFloat(this_price) / 4.0
  $(".affirm-price").html("$" + payment_price.toFixed(2))

  //update "In the box" area
  $(".in-the-box-wrapper").hide()
  $(".in-the-box-wrapper[data-variant='"+this_variant+"']").show()
}




function init(){
  //get the initial variant, either by deep link or by first available
  var preselected_variant = toolkit.get_query_variable("variant")

  if (preselected_variant == "")
    preselected_variant = "{{product.first_available_variant.id}}"



  //select it in the main <select> tag
  $("#product-select").find(`option[data-id='`+preselected_variant+`']`).prop('selected', true)

  var option_1 = $("#product-select").find("option:selected").attr("data-option-1")
  var option_2 = $("#product-select").find("option:selected").attr("data-option-2")
  var option_3 = $("#product-select").find("option:selected").attr("data-option-3")

  //create the initial state of inputs
  var options = [option_1,option_2,option_3]
  for (var option of options){
    if (option == "") continue
    var props = `[data-value='`+option+`']`
    $(".product-options").find(`.option-button` + props).addClass('active')
    $(".options-in-header").find(`.option-button` + props).addClass('active')
  }

  update_selected_variant()
  update_image()

  setup_option_click_handlers()

  var should_show_oos_immediately = toolkit.get_query_variable("notify")
  if (should_show_oos_immediately == "true"){
    $(".bis-popup").addClass("active")
    $("html").addClass("stuck")
  }
}


init();


function update_image(){
  var selected_color = $(".option .swatch.active").attr("data-color")
  var new_image_preview = $(".image-select .image-thumb[data-color='"+selected_color+"']")

  var new_image_url = $(new_image_preview).attr("data-url")

  if (!new_image_url) return

  $(".primary-image").css("background-image", "url(" + new_image_url + ")")

  var new_index = new_image_preview.index()
  // console.log("new index:" + new_index)
  // console.log(prod_image_swiper)

  $(".image-select .swiper-slide").hide()
  $(".image-select .swiper-slide[data-color='"+selected_color+"']").show()
  $(".image-select .swiper-slide[data-color='']").show()
  prod_image_swiper.update(new_index)
  prod_image_swiper.slideTo(0)


  $(".primary-image").trigger('zoom.destroy');
  $(".primary-image").zoom({url: new_image_preview.attr("data-url-big") });

}

function setup_option_click_handlers(){
  $(".option .option-button").click(function(){
    //deselect previous choice... globally

    var this_option_name = $(this).closest(".option").attr("data-option")
    var this_option_value = $(this).attr("data-value")
    var option_container = $(".option[data-option='"+this_option_name+"']")
    option_container.find(".option-button.active").removeClass("active")

    //select this choice
    option_container.find(".option-button[data-value='"+this_option_value+"']").addClass("active")
    //$(this).addClass("active")

    //update state
    update_selected_variant()
    update_image()
  })
}








async function submit_bis(email, variant_id){

  return new Promise(async function(resolve){
    var klaviyo_key = 'LPbCiJ'
    var platform = "shopify"

    fetch("https://a.klaviyo.com/onsite/components/back-in-stock/subscribe", {
      "headers": {
        "accept": "application/json, text/plain, */*",
        "content-type": "application/x-www-form-urlencoded;charset=UTF-8",
      },
      "body": new URLSearchParams({
          "a": klaviyo_key,
          "email": email,
          "platform": "shopify",
          "variant": variant_id,
          "product": bis_product_id,
      }),
      "method": "POST",
    })
    .then(async function(response){
      var body = await response.json()
      console.log(body)
      resolve(body)
    })
    .catch(err => {
      console.error(err);
      resolve(err)
    });


  })


  async function postData(url = '', data = {}) {
    // Default options are marked with *
    const response = await fetch(url, {
      method: 'POST', // *GET, POST, PUT, DELETE, etc.
      mode: 'cors', // no-cors, *cors, same-origin
      cache: 'no-cache', // *default, no-cache, reload, force-cache, only-if-cached
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
      },
      redirect: 'follow', // manual, *follow, error
      referrerPolicy: 'no-referrer', // no-referrer, *no-referrer-when-downgrade, origin, origin-when-cross-origin, same-origin, strict-origin, strict-origin-when-cross-origin, unsafe-url
      body: data // body data type must match "Content-Type" header
    });
    return response
  }

}





//misc page interaction things
$(function(){

  var was_adding_from_pdp = false

  //this doesn't seem right. Everywhere else uses the "success" callback from CartJS
  $(document).on('cart.requestComplete', function(event, cart) {
    //get the top-most line item and add it to the sidecart
    sidecart.slide_out();
    if (was_adding_from_pdp){
      sidecart.cartjs_add_this_product(cart.items[0])
      was_adding_from_pdp = false
    }
  })



  $(".description-truncated .read-more").click(function(){
    $(".description-truncated").hide()
    $(".description-full").show()
  })


  $(".primary-video .close-video").click(function(){
    $(".primary-video").hide().removeClass("active")
  })

  $(".qty-select .minus").click(function(){
    var current_number = parseInt($(this).closest(".qty-select").find(".qty-number").text())
    if (current_number == 1) return

    $(this).closest(".qty-select").find(".qty-number").text(current_number - 1)
  })
  $(".qty-select .plus").click(function(){
    var current_number = parseInt($(this).closest(".qty-select").find(".qty-number").text())

    if (current_number >= 15) return

    $(this).closest(".qty-select").find(".qty-number").text(current_number + 1)
  })


  $(".atc-trigger.primary").click(function(){

    $(".atc-trigger.primary").text("Adding...")

    var qty = parseInt($(".product-split .qty-number").text())
    var variant_id = parseInt($("#product-select").val())

    was_adding_from_pdp = true
    CartJS.addItem(variant_id, qty, {}, {
        "success": function(data, textStatus, jqXHR) {

          $(".atc-trigger.primary").text("Add to Cart")
        },
        "error": function(jqXHR, textStatus, errorThrown) {
            $(".atc-trigger.primary").text("Add to Cart")
        }
    });


  })


  $(".notify-trigger").click(function(){
    $(".bis-popup").addClass("active")
    $("html").addClass("stuck")
  })
  $(".bis-popup .close").click(function(){
    $(".bis-popup").removeClass("active")
    $("html").removeClass("stuck")
  })
  $(".bis-popup .button").click(async function(){
    var email = $("#bis_email").val()
    var variant = toolkit.get_query_variable("variant")
    if (email == "") {
      $(".bis-error").html("Please enter a valid email address")
      return
    }

    var response_json = await submit_bis(email, variant)
    if (response_json.success){
      $(".bis-error").html("Thank you!")
      $(".bis-popup input").hide()
      $(".bis-popup .button").hide()
      $(".bis-description").hide()
    }
    else {
      $(".bis-error").html("There was an error")
    }
  })

  $(".bis-popup").click(function(){
    $(".bis-popup").removeClass("active")
    $("html").removeClass("stuck")
  })
  $(".bis-popup .inner").click(function(e){
    e.stopImmediatePropagation()
    e.stopPropagation()

  })

  $(".upsells .atc-trigger").click(function(){

    $(this).text("Adding...")
    var that = this

    var variant_id = parseInt($(this).closest(".upsell-product").attr("data-variant-id"))
    was_adding_from_pdp = true
    CartJS.addItem(variant_id, 1, {}, {
        "success": function(data, textStatus, jqXHR) {
          $(that).text("Add to Cart")
        },
        "error": function(jqXHR, textStatus, errorThrown) {
          $(that).text("Add to Cart")
        }
    });


  })


})
